import Component from './lifestyle-actions.component'

export default Component
